<div class="row page-header">
  <div *ngIf="icon"><span class="fa {{icon}}"></span></div>
  {{ heading }}
</div>
